import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface BrandProps {
  compact?: boolean;
  className?: string;
  /** Full approved artwork for larger placements; compact icon for navigation. */
  artwork?: boolean;
  subtitle?: string;
}

export default function Brand({ compact = false, className = '', artwork = false, subtitle }: BrandProps) {
  return (
    <span className={`brand ${compact ? 'brand--compact' : ''} ${artwork ? 'brand--artwork' : ''} ${className}`}>
      <img
        src={`/branding/vivaassess-${artwork ? 'logo' : 'icon'}.webp`}
        alt={artwork || compact ? 'VivaAssess' : ''}
        width={1200}
        height={artwork ? 800 : 1200}
        decoding="sync"
      />
      {!artwork && !compact && (subtitle ? <span className="staff-brand-identity">
        <span className="brand__wordmark">Viva<span>Assess</span></span>
        <span className="staff-brand-subtitle">{subtitle}</span>
      </span> : <span className="brand__wordmark">Viva<span>Assess</span></span>)}
    </span>
  );
}

export function BrandHome({ className = '' }: { className?: string }) {
  const { t } = useTranslation('common');
  return <Link to="/" className={className} aria-label={t('accessibility.goToHomepage')}><Brand /></Link>;
}
